import React, { useEffect, useState } from 'react'
import MainLayouts from '../../layouts/MainLayouts'
import { _Button, _Checkbox, _Input, _Select, _Date } from '../../services/Forms/Forms'

import { Table, Form, Popover, Button, Tag, Popconfirm, Radio, DatePicker, Checkbox, Image } from 'antd';
import { useHistory } from 'react-router';
// import "../../assets/css/style_dua.css"
import "./../../assets/css/style_dua.css"
import { logo } from 'auth/index.js';



function Home() {

    const [steps, setsteps] = useState(0)
    const [jenisPekerjaan, setjenisPekerjaan] = useState([])
    const [riwayatKonseling, setriwayatKonseling] = useState([])
    const [ppk, setppk] = useState([])
    const [loading, setloading] = useState(false)
    const [jenispk, setjenispk] = useState("")
    const [formLoad] = Form.useForm()
    const [edit, setedit] = useState(false)
    const [recordData, setrecordData] = useState([])
    const [jenisArsip, setjenisArsip] = useState([])


    var histori = useHistory()

    // const DragHandle = sortableHandle(() => <MenuOutlined style={{ cursor: 'grab', color: '#999' }} />);


    // const { status, startRecording, stopRecording, mediaBlobUrl } =
    //     useReactMediaRecorder({ video: true });


    const gotoKonseling = () => {
        histori.push("/OrderKonseling?ssl=ks")

    }
    const stile = {
        title: {
            fontWeight: "bold", borderColor: "orange", color: "#542615", marginBottom: "0px", marginTop: "5px",
            fontFamily: "BrothersCircus, Arial, serif"
        }
    }
    return (
        <MainLayouts>
            <br />
            <div className="container-center">
                <div className='center-screen'>
                    <center>
                        <Image src={logo} style={{width:"40vh"}} className='hide-mobile' preview={false} />
                        <h1 style={stile.title}>  KONSELING GIZI  <span style={{ color: '#9a3813' }}> <br /> RSUD H. Moh. Ruslan </span></h1>
                        <br />
                        <h1>  <b style={{ textTransform: "capitalize", fontFamily:"AdventPro" }}> Pola makan yang seimbang adalah investasi dalam kesehatan masa depan Anda. </b></h1>
                        <Button type='gost' className='blink_me' style={{ height: "100%", width :"300px", borderRadius: "10px" }} onClick={gotoKonseling}>
                            <img src="/img/menu/video-conference.png" height={50} alt="" />
                            <br />
                            <b> Konseling Sekarang </b> </Button>
                    </center>
                </div>

            </div>
            <div>
                {/* <Button onClick={buatFolder}>Buat Directory</Button> */}

                {/* <ScreenRecorder /> */}
            </div>

        </MainLayouts >
    )
}

export default Home
